import React from 'react'
import { Switch as RouterSwitch, Route,Redirect } from 'react-router-dom'
import authServices from '../services/auth'

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={(props) => ( 
		authServices.isLoggin() === true ? <Component {...props} /> : <Redirect to='/login' />
	)} />
)
export default PrivateRoute